/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Radio = require('backbone.radio');
var Ladda = require('ladda');

var BreadcrumbView = require('common/views/BreadcrumbView');

var eventVenueDetailsForm = require('../views/COCEventVenueDetailsView');
var SubmitEditEventVenueDetails = require('../services/SubmitEditEventVenueDetails');

var tmplCOCEditEventVenueDetails = require('../templates/COCEditEventVenueDetailsView.hbs');
require('../styles/COCEditEventVenueDetailsView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEditEventVenueDetails,

  className: 'coc-edit-event-venue-details container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    eventVenueDetailsContainer: '.event-venue-details-container',
    submit: '.btn-submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    eventVenueDetailsContainer: '@ui.eventVenueDetailsContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var event = this.model.get('event');
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#coc/dashboard',
            text: 'Home'
          },
          {
            link: '#coc/event/' + event.eventId,
            text: event.eventTitle
          },
          {
            text: 'Edit Venue Details'
          }
        ]
      })
    );
    var eventVenueDetailsModel = this.model;
    this.showChildView('eventVenueDetailsContainer', new eventVenueDetailsForm({ model: eventVenueDetailsModel }));
    Syphon.deserialize(this, event);
  },

  validate: function() {
    return this.ui.eventVenueDetailsContainer.parsley().whenValidate();
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var l = Ladda.create(this.ui.submit[0]);
    l.start();
    var event = this.model.get('event');
    var formData = Syphon.serialize(this);
    formData.eventId = event.eventId;
    formData.venueId = this.model.get('venueId');
    formData.contactId = this.model.get('venueContactId');
    formData.venueAddress = this.model.get('venueAddress');
    formData.eventFormatId = event.eventFormatId;
    this.validate().done(function() {
      SubmitEditEventVenueDetails(formData)
        .done(function() {
          Radio.channel('navigate').trigger('show:int:coc:event', event.eventId);
        })
        .fail(function() {
          l.stop();
        });
    });
  }
});
